import React from 'react';

export const ThemeContext = React.createContext({});
export const TypeContext = React.createContext('Quick Report');
